var map = {
	"./": 70148,
	"./App": 53671,
	"./App.css": 57200,
	"./App.js": 53671,
	"./App.test": 53270,
	"./App.test.js": 53270,
	"./about/About": 13617,
	"./about/About.css": 70512,
	"./about/About.jsx": 13617,
	"./about/acknowledgments/Acknowledgments": 20115,
	"./about/acknowledgments/Acknowledgments.css": 70482,
	"./about/acknowledgments/Acknowledgments.jsx": 20115,
	"./about/definition/Definition": 15167,
	"./about/definition/Definition.css": 4650,
	"./about/definition/Definition.jsx": 15167,
	"./about/definition/DefinitionCard": 74909,
	"./about/definition/DefinitionCard.css": 68400,
	"./about/definition/DefinitionCard.jsx": 74909,
	"./about/mission/Mission": 42834,
	"./about/mission/Mission.css": 80226,
	"./about/mission/Mission.jsx": 42834,
	"./about/mission/MissionItem": 4202,
	"./about/mission/MissionItem.jsx": 4202,
	"./about/team/Team": 6591,
	"./about/team/Team.css": 54050,
	"./about/team/Team.jsx": 6591,
	"./about/team/helper/Leaders": 51611,
	"./about/team/helper/Leaders.css": 96950,
	"./about/team/helper/Leaders.jsx": 51611,
	"./about/team/helper/PastResearchers": 46629,
	"./about/team/helper/PastResearchers.jsx": 46629,
	"./about/team/helper/Researchers": 19156,
	"./about/team/helper/Researchers.css": 89773,
	"./about/team/helper/Researchers.jsx": 19156,
	"./about/team/helper/gravatar": 76430,
	"./about/team/helper/gravatar.js": 76430,
	"./about/values/JediCard": 46863,
	"./about/values/JediCard.jsx": 46863,
	"./about/values/Values": 31897,
	"./about/values/Values.css": 72332,
	"./about/values/Values.jsx": 31897,
	"./assets/event/eventView.png": 30948,
	"./assets/event/events": 41385,
	"./assets/event/events.json": 41385,
	"./assets/event/gis/CableCenterExterior.jpeg": 16332,
	"./assets/event/gis/GISintheRockies.png": 83964,
	"./assets/img/acknowledgments/USNSF_Logo_Lockup_stacked_RGB_1200ppi.png": 86342,
	"./assets/img/carousel/buffalo2BenjCollins.jpg": 90045,
	"./assets/img/carousel/buffaloBenjCollins.jpg": 99813,
	"./assets/img/carousel/colorfulColoradoAustinSullivan.jpg": 83642,
	"./assets/img/carousel/denverCassieGallegos.jpg": 16293,
	"./assets/img/carousel/denverSkylineNoelace.jpg": 71719,
	"./assets/img/carousel/dunesBenjCollins.jpg": 40571,
	"./assets/img/carousel/eagleBenjCollins.jpg": 81376,
	"./assets/img/carousel/elkBenjCollins.jpg": 5682,
	"./assets/img/carousel/gardenOfGodsMelanieMagdalena.jpg": 93615,
	"./assets/img/carousel/mana5280.jpg": 87859,
	"./assets/img/carousel/mesaCuongDinh.jpg": 65660,
	"./assets/img/carousel/morrisonJustinWang.jpg": 14614,
	"./assets/img/carousel/mountainLakeBenjCollins.jpg": 90116,
	"./assets/img/carousel/mountains2CuongDinh.jpg": 60256,
	"./assets/img/carousel/mountainsCuongDinh.jpg": 23474,
	"./assets/img/carousel/roadwayBrianaTozour.jpg": 1378,
	"./assets/img/carousel/rockyMountainPeterPryharski.jpg": 5267,
	"./assets/img/definition/archive/economy.png": 21317,
	"./assets/img/definition/archive/environment.png": 70338,
	"./assets/img/definition/archive/society.png": 59939,
	"./assets/img/definition/economy.png": 97974,
	"./assets/img/definition/environment.png": 86861,
	"./assets/img/definition/society.png": 78524,
	"./assets/img/icons/svg/impact.svg": 884,
	"./assets/img/icons/svg/methods.svg": 45200,
	"./assets/img/icons/svg/relevance.svg": 83623,
	"./assets/img/icons/svg/search.svg": 9370,
	"./assets/img/logos/png/blackWhite.png": 16371,
	"./assets/img/logos/png/blueBackground.png": 50367,
	"./assets/img/logos/png/logoSquare.png": 62903,
	"./assets/img/logos/svg/blackWhite.svg": 78824,
	"./assets/img/logos/svg/blueBackground.svg": 22900,
	"./assets/img/logos/svg/emailIcon.svg": 54031,
	"./assets/img/logos/svg/facebookIcon.svg": 92587,
	"./assets/img/logos/svg/githubIcon.svg": 52526,
	"./assets/img/logos/svg/instagramIcon.svg": 75155,
	"./assets/img/logos/svg/linkedinIcon.svg": 17985,
	"./assets/img/logos/svg/phoneIcon.svg": 72163,
	"./assets/img/logos/svg/userIcon.svg": 18410,
	"./assets/img/logos/svg/xIcon.svg": 80951,
	"./assets/project/projectView.png": 99564,
	"./assets/project/projects": 9409,
	"./assets/project/projects.json": 9409,
	"./assets/project/urcSp24/Sp24DataTeam.jpg": 69012,
	"./assets/project/urcSp24/Sp24UITeam.jpg": 51638,
	"./assets/scss/custom.scss": 33498,
	"./assets/team/teams": 78713,
	"./assets/team/teams.json": 78713,
	"./common/ButtonTest": 18662,
	"./common/ButtonTest.jsx": 18662,
	"./common/popUpPage/PopUpPage": 51146,
	"./common/popUpPage/PopUpPage.css": 2334,
	"./common/popUpPage/PopUpPage.jsx": 51146,
	"./communityEvents/CommunityEvents": 70705,
	"./communityEvents/CommunityEvents.css": 14352,
	"./communityEvents/CommunityEvents.jsx": 70705,
	"./communityEvents/EventCard": 10619,
	"./communityEvents/EventCard.css": 34306,
	"./communityEvents/EventCard.jsx": 10619,
	"./contactUs/ContactInfo": 85989,
	"./contactUs/ContactInfo.css": 33168,
	"./contactUs/ContactInfo.jsx": 85989,
	"./contactUs/ContactUs": 40868,
	"./contactUs/ContactUs.css": 44228,
	"./contactUs/ContactUs.jsx": 40868,
	"./footer/Footer": 49922,
	"./footer/Footer.css": 27512,
	"./footer/Footer.jsx": 49922,
	"./homePage/HomePage": 79903,
	"./homePage/HomePage.css": 48110,
	"./homePage/HomePage.jsx": 79903,
	"./index": 70148,
	"./index.css": 31685,
	"./index.js": 70148,
	"./logo.svg": 69445,
	"./navBar/NavBar": 27151,
	"./navBar/NavBar.css": 33570,
	"./navBar/NavBar.jsx": 27151,
	"./navBar/SearchComponent": 5920,
	"./navBar/SearchComponent.jsx": 5920,
	"./projectUpdates/ProjectCard": 12169,
	"./projectUpdates/ProjectCard.css": 81278,
	"./projectUpdates/ProjectCard.jsx": 12169,
	"./projectUpdates/ProjectUpdates": 1881,
	"./projectUpdates/ProjectUpdates.css": 39475,
	"./projectUpdates/ProjectUpdates.jsx": 1881,
	"./reportWebVitals": 7775,
	"./reportWebVitals.js": 7775,
	"./setupTests": 75288,
	"./setupTests.js": 75288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;